export default [
  { id: 1, label: "EDITAL ART. 52, § 1º" },
  { id: 2, label: "EDITAL ART. 7º, § 2º" },
  { id: 3, label: "QGC Consolidado" }
]
